import { buildQueryUrl } from '@loc/helpers/src/buildQueryUrl'

import { useAppUIModal } from '@/contexts/AppUIModalContext'


import { useUrl, useOrigin, useRouter } from '@/hooks/routes';
import { useMemo } from 'react';
export function usePaidSuccessfullyUrl() {
  const urlObj = useUrl()
  const [origin] = useOrigin()
  const router = useRouter()
  const { upgradePlan } = useAppUIModal()

  const redirect = router.query?.redirect

  const paidSuccessfullyUrl = useMemo(() => {
    return `${origin}/paid-successfully?redirect=/`
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router, origin])

  const params: any = {}

  params.redirect = redirect

  const getPaidSuccessfullyUrl = (params: Record<string, any>) => {
    let redirect = urlObj.href

    if (router.asPath.startsWith('/pricing')) {
      // dashboard 或者 首页
      redirect = '/'
    }
    const _params: Record<string, any> = {
      ...params,
      redirect,
    }
    // 升级弹窗触发来源（如 ai_music_check），用于 paid_features 埋点
    const triggerMethod = upgradePlan.data.method
    if (triggerMethod && triggerMethod !== 'click_Subscription_button') {
      _params.triggerMethod = triggerMethod
    }
    return buildQueryUrl(`${origin}/paid-successfully`, _params)
  }

  return {
    paidSuccessfullyUrl,
    getPaidSuccessfullyUrl,
  }
}
